import styled from '@emotion/styled';

const InfoWrapper = styled('div')({
  float: 'left',
  width: 'calc(100% - 8.6rem)',
});

export default InfoWrapper;
